import { UserAccessRightsGuard } from './../role/user-role/user-access-rights.guard'
import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'
import { BookingCreateComponent } from './create/create.component'
import { BookingRepeatTabComponent } from './repeat-tab/show.component'
import { BookingIndexComponent } from './index/index.component'
import { BookingOverviewComponent } from './overview/show.component'
import { BookingParticipationTabComponent } from './participation-tab/show.component'
import { BookingShowComponent } from './show/show.component'
import { BookingSaleTabComponent } from './sale-tab/show.component'
import { BookingAllowedLinkedProductTabComponent } from './allowed-product-tab/show.component'
import { BookingGeneralTabComponent } from './general-tab/show.component'
import { BookingDetailsTabComponent } from './details-tab/show.component'
import { BookingSupervisorTabComponent } from './supervisor-tab/show.component'
import { BookingDocumentsTabComponent } from './documents-tab/show.component'
import { AccessRights } from '../role/user-role/user-role'
import { LogsTabComponent } from './logs-tab/logs-tab.component'
import { BookingCommunicationTabComponent } from './communication-tab/show.component'
import { SurveyAnswersComponent } from '../survey/answers-tab/show.component'
import { OperationTabComponent } from './operation-tab/operation-tab.component'
import { BookingSerieTabComponent } from './booking-serie-tab/show.component'
import { SerieProposalShowComponent } from './serie-proposal/show/show.component'
import { SerieProposalSeriesTabComponent } from './serie-proposal/series-tab/show.component'
import { SerieProposalMessagesTabComponent } from './serie-proposal/messages-tab/messages-tab.component'
import { SerieProposalGeneralTabComponent } from './serie-proposal/general-tab/show.component'
import { SerieProposalSalesTabComponent } from './serie-proposal/sales-tab/show.component'

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    component: BookingIndexComponent,
    canActivate: [UserAccessRightsGuard],
    data: { accessRights: [AccessRights.Bookings_read] }
  },
  {
    path: 'create',
    component: BookingCreateComponent,
    canActivate: [UserAccessRightsGuard],
    data: { accessRights: [AccessRights.Bookings_write] }
  },
  {
    path: 'serie-proposals/:serieProposalId',
    component: SerieProposalShowComponent,
    canActivate: [UserAccessRightsGuard],
    data: { accessRights: [AccessRights.Bookings_read] },
    children: [
      {
        path: '',
        component: SerieProposalGeneralTabComponent,
        pathMatch: 'full'
      },
      { path: 'series', component: SerieProposalSeriesTabComponent },
      {
        path: 'messages',
        component: SerieProposalMessagesTabComponent
      },
      {
        path: 'sales',
        component: SerieProposalSalesTabComponent
      }
    ]
  },
  {
    path: ':bookingId',
    component: BookingShowComponent,
    canActivate: [UserAccessRightsGuard],
    data: { accessRights: [AccessRights.Bookings_read] },
    children: [
      { path: '**', redirectTo: '' }
      // disabled until we refactor all modals, as a quick solution now, we just show the booking show modal inside the booking show component so we dont duplicate any logic
      //   { path: '', component: BookingGeneralTabComponent, pathMatch: 'full' },
      //   { path: 'details', component: BookingDetailsTabComponent },
      //   { path: 'participation', component: BookingParticipationTabComponent },
      //   { path: 'operations', component: OperationTabComponent },
      //   { path: 'repeat', component: BookingRepeatTabComponent },
      //   { path: 'seriesManagement', component: BookingSerieTabComponent },
      //   { path: 'supervisors', component: BookingSupervisorTabComponent },
      //   { path: 'sales', component: BookingSaleTabComponent },
      //   {
      //     path: 'allowed-linked-products',
      //     component: BookingAllowedLinkedProductTabComponent
      //   },
      //   { path: 'documents', component: BookingDocumentsTabComponent },
      //   { path: 'communication', component: BookingCommunicationTabComponent },
      //   { path: 'logs', component: LogsTabComponent },
      //   { path: 'surveys', component: SurveyAnswersComponent }
    ]
  }
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class BookingRoutingModule {}
